import React from 'react';

import Dashboard from './components/Dashboard.jsx';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx'


function App() {

  return (
    <>
      <Header />
      <Dashboard />
      <Footer />
    </>
  );
}

export default App;
